"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatHub = void 0;
class ChatHub {
    set Connection(connection) {
        this.connection = connection;
    }
    get Connection() {
        return this.connection;
    }
    sendMessage(conversationId, message) {
        return this.Connection.invoke('SendMessage', conversationId, message);
    }
    deleteConversation(conversationId) {
        return this.Connection.invoke('DeleteConversation', conversationId);
    }
    markConversationAsRead(conversationId) {
        return this.Connection.invoke('MarkConversationAsRead', conversationId);
    }
    deleteMessage(conversationId, messageId) {
        return this.Connection.invoke('DeleteMessage', conversationId, messageId);
    }
    markAllMessagesAsRead() {
        return this.Connection.invoke('MarkAllMessagesAsRead');
    }
    getConversations(conversationUpdatedAt) {
        return this.Connection.invoke('GetConversations', conversationUpdatedAt);
    }
    getConversation(otherUserId) {
        return this.Connection.invoke('GetConversation', otherUserId);
    }
    getConversationMessages(conversationId, lastMessageTimestamp) {
        return this.Connection.invoke('GetConversationMessages', conversationId, lastMessageTimestamp);
    }
    subscribeToPresence(otherUserId) {
        return this.Connection.invoke('SubscribeToPresence', otherUserId);
    }
    unsubscribeFromPresence(otherUserId) {
        return this.Connection.invoke('UnsubscribeFromPresence', otherUserId);
    }
    registerCallbacks(implementation) {
        this.Connection.on('ConversationDeleted', (conversationDeletedData) => implementation.conversationDeleted(conversationDeletedData));
        this.Connection.on('MessageDeleted', (messageDeletedData) => implementation.messageDeleted(messageDeletedData));
        this.Connection.on('MarkAllMessagesAsRead', () => implementation.markAllMessagesAsRead());
        this.Connection.on('MarkConversationAsRead', (markConversationAsReadData) => implementation.markConversationAsRead(markConversationAsReadData));
        this.Connection.on('MessageRecieved', (messageRecievedData) => implementation.messageRecieved(messageRecievedData));
        this.Connection.on('PresenceUpdate', (presenceUpdateData) => implementation.presenceUpdate(presenceUpdateData));
    }
    unregisterCallbacks(implementation) {
        this.Connection.off('ConversationDeleted', (conversationDeletedData) => implementation.conversationDeleted(conversationDeletedData));
        this.Connection.off('MessageDeleted', (messageDeletedData) => implementation.messageDeleted(messageDeletedData));
        this.Connection.off('MarkAllMessagesAsRead', () => implementation.markAllMessagesAsRead());
        this.Connection.off('MarkConversationAsRead', (markConversationAsReadData) => implementation.markConversationAsRead(markConversationAsReadData));
        this.Connection.off('MessageRecieved', (messageRecievedData) => implementation.messageRecieved(messageRecievedData));
        this.Connection.off('PresenceUpdate', (presenceUpdateData) => implementation.presenceUpdate(presenceUpdateData));
    }
}
exports.ChatHub = ChatHub;
//# sourceMappingURL=ChatHub.js.map